import { render, staticRenderFns } from "./CompanyPersons.vue?vue&type=template&id=39b932b4&"
import script from "./CompanyPersons.vue?vue&type=script&lang=js&"
export * from "./CompanyPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CompanyPersons.vue"
export default component.exports